import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'
import { AccountData } from '../lib/types'

export default class FormSmsOptInController extends Controller {
  static targets = ['checkbox']
  declare checkboxTarget: HTMLInputElement

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.setInitialValues()
  }

  setInitialValues() {
    const sms_opt_in = this.checkoutOutlet.signupData.account?.sms_opt_in
    // Explicitly handle boolean values
    this.checkboxTarget.checked = sms_opt_in === true
  }

  toggleCheckbox(event: Event) {
    const checkbox = event.target as HTMLInputElement

    if (!this.checkoutOutlet.signupData.account) {
      this.checkoutOutlet.signupData.account = {} as AccountData
    }

    this.checkoutOutlet.signupData.account = {
      ...this.checkoutOutlet.signupData.account,
      sms_opt_in: checkbox.checked,
    }
  }
}
